import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { enumParser, MigrationBlocker, MigrationStatus } from '#validation';
const baseClassicMigrationFilespaceSchema = z.object({
    id: z.string(),
    name: z.string(),
    migrationStatus: enumParser(MigrationStatus),
    migrationBlocker: enumParser(MigrationBlocker).optional(),
});
export const classicMigrationFilespaceSummarySchema = baseClassicMigrationFilespaceSchema.extend({
    usedStorage: z.number(),
    usersCount: z.number(),
    region: z.string(),
    storageProvider: z.string(),
    subscriptionType: z.string(),
});
export const classicFilespaceEligibleForMigrationSummarySchema = classicMigrationFilespaceSummarySchema.extend({
    isSelected: z.boolean().default(false),
    canRemove: z.boolean().default(false),
});
const classicHubSizeSchema = z.object({
    slug: z.string(),
    memory: z.number(),
    vcpus: z.number(),
    disk: z.number(),
});
const classicMigrationFilespaceSchema = baseClassicMigrationFilespaceSchema.extend({
    fsId: z.string(),
    domainName: z.string(),
    version: z.number(),
    hub: z
        .object({
        ip: z.string(),
        privateIp: z.string(),
        size: classicHubSizeSchema,
        region: z.string(),
        backupRegion: z.string().optional(),
        provider: z.string(),
        hostId: z.string(),
    })
        .optional(),
});
export class ClassicMigrationFilespaceDto extends createZodDto(classicMigrationFilespaceSchema) {
}
const classicMigrationFilespacesResponseSchema = z.object({
    filespaces: z.array(classicMigrationFilespaceSummarySchema),
});
const classicFilespacesEligibleForMigrationResponseSchema = z.object({
    filespaces: z.array(classicFilespaceEligibleForMigrationSummarySchema),
});
export class ClassicMigrationFilespacesResponseDto extends createZodDto(classicMigrationFilespacesResponseSchema) {
}
export class ClassicFilespacesEligibleForMigrationResponseDto extends createZodDto(classicFilespacesEligibleForMigrationResponseSchema) {
}
export const classicMigrationFilespaceUserSchema = z.object({
    username: z.string(),
});
const classicMigrationFilespaceUsersResponseSchema = z.object({
    users: z.array(classicMigrationFilespaceUserSchema),
});
export class ClassicMigrationFilespaceUsersResponseDto extends createZodDto(classicMigrationFilespaceUsersResponseSchema) {
}
export const migrationBillingPathSchema = z.enum(['slg', 'plg']);
const classicMigrationDomainResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    hasSso: z.boolean(),
    canMigrate: z.boolean(),
    // Which billing flow a migration of this domain will take: 'slg'
    // (Salesforce-contract based, including the partner-organization and
    // lucidlink test-contract flows) or 'plg' (self-serve Legacy Custom).
    // Resolved with the same discriminator workspace creation uses, so the
    // upgrade tool can branch its wizard (e.g. the credit card step) upfront.
    migrationBillingPath: enumParser(migrationBillingPathSchema.enum),
});
export class ClassicMigrationDomainResponseDto extends createZodDto(classicMigrationDomainResponseSchema) {
}
